// extracted by mini-css-extract-plugin
export var dropdownButton = "_1y-0";
export var fullWidthDropdownButton = "_1y-1";
export var icon = "_1y-3";
export var iconPlaceholder = "_1y-2";
export var menuItemRow = "_1y-8";
export var separator = "_1y-d";
export var shortcutContainer = "_1y-7";
export var shortcutIconLg = "_1y-6";
export var shortcutIconMd = "_1y-5";
export var shortcutIconSm = "_1y-4";
export var submenuChevron = "_1y-c";
export var submenuDropdown = "_1y-9";
export var submenuTriggerRow = "_1y-a";
export var submenuTriggerRowOpen = "_1y-b";